import { render, staticRenderFns } from "./CreateContactModal.vue?vue&type=template&id=00cb8573"
import script from "./CreateContactModal.vue?vue&type=script&lang=js"
export * from "./CreateContactModal.vue?vue&type=script&lang=js"
import style0 from "./CreateContactModal.vue?vue&type=style&index=0&id=00cb8573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports